const runtimeEnv = (typeof window !== 'undefined' && window._env_) || {}

export function getEnv(key, fallback) {
  const value = runtimeEnv[key] ?? process.env[key]
  return value === undefined || value === '' ? fallback : value
}
